import { Injectable } from '@angular/core';

import { PATIENT_SORT_DEFAULTS } from '../patients-api';

/**
 * Zaznaczenia panelu listy podopiecznych żyją tutaj, bo router tworzy `DashboardComponent`
 * od nowa przy każdym wejściu na listę. W pamięci, nie w `localStorage`: odświeżenie strony
 * i wylogowanie (`UserService.purgeAuth`) wracają do ustawień domyślnych.
 */
@Injectable({ providedIn: 'root' })
export class PatientListStateService {
  sortSelection: string[];
  sortDirection: 'asc' | 'desc';
  filterSelection: string[];
  /** Zaznaczone projekty (id) — osobno od `filterSelection`, bo tamte klucze to stany opaski. */
  projectSelection: number[];

  constructor() {
    this.clear();
  }

  clear(): void {
    this.sortSelection = PATIENT_SORT_DEFAULTS.slice();
    this.sortDirection = 'asc';
    this.filterSelection = [];
    this.projectSelection = [];
  }
}
